var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8839 13.1977C15.591 13.4906 15.591 13.9654 15.8839 14.2583C16.1768 14.5512 16.6517 14.5512 16.9445 14.2583L15.8839 13.1977ZM8.81282 6.12662C8.51992 6.41951 8.51992 6.89438 8.81282 7.18728C9.10571 7.48017 9.58058 7.48017 9.87348 7.18728L8.81282 6.12662ZM14.1161 17.0868C14.409 16.7939 14.409 16.319 14.1161 16.0261C13.8232 15.7332 13.3483 15.7332 13.0555 16.0261L14.1161 17.0868ZM7.04505 10.0157C7.33794 9.72281 7.33794 9.24794 7.04505 8.95504C6.75216 8.66215 6.27728 8.66215 5.98439 8.95504L7.04505 10.0157ZM18.0052 11.0764L15.8839 13.1977L16.9445 14.2583L19.0659 12.137L18.0052 11.0764ZM9.87348 7.18728L11.9948 5.06596L10.9341 4.0053L8.81282 6.12662L9.87348 7.18728ZM13.0555 16.0261L10.9341 18.1474L11.9948 19.2081L14.1161 17.0868L13.0555 16.0261ZM4.92373 12.137L7.04505 10.0157L5.98439 8.95504L3.86307 11.0764L4.92373 12.137ZM4.92373 18.1474C3.264 16.4877 3.264 13.7968 4.92373 12.137L3.86307 11.0764C1.61755 13.3219 1.61755 16.9626 3.86307 19.2081L4.92373 18.1474ZM3.86307 19.2081C6.10858 21.4536 9.74928 21.4536 11.9948 19.2081L10.9341 18.1474C9.27441 19.8072 6.58346 19.8072 4.92373 18.1474L3.86307 19.2081ZM18.0052 5.06596C19.6649 6.72568 19.6649 9.41663 18.0052 11.0764L19.0659 12.137C21.3114 9.89151 21.3114 6.25081 19.0659 4.0053L18.0052 5.06596ZM19.0659 4.0053C16.8203 1.75978 13.1797 1.75978 10.9341 4.0053L11.9948 5.06596C13.6545 3.40623 16.3455 3.40623 18.0052 5.06596L19.0659 4.0053Z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5858 9.48537L9.34314 13.728",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link.d757d7b4aa8f4863b0feee87d2ba82c2.svg";